import { Editor } from '../../../Components/Common/Editor'
import { cap } from '../../../State'
import { translations } from '../../../translations'
import CheckboxPanel from './CheckBoxPanel'

const language = cap.language.state || 'IT'
const t = translations[language]

const Controlli = ({
  userRedirectToOperatorMessage: [userRedirectToOperatorMessage, setUserRedirectToOperatorMessage],
  checkUserRedirectToOperatorMessage: [
    checkUserRedirectToOperatorMessage,
    setCheckUserRedirectToOperatorMessage
  ],
  checkAutomaticHotel: [checkAutomaticHotel, setCheckAutomaticHotel],
  checkControlliIA: [checkControlliIA, setCheckControlliIA],
  checkPubblicaLoStesso: [checkPubblicaLoStesso, setCheckPubblicaLoStesso],
  checkControllaPreventivi: [checkControllaPreventivi, setCheckControllaPreventivi],
  checkChiediMezzoDiTrasporto: [checkChiediMezzoDiTrasporto, setCheckChiediMezzoDiTrasporto],
  signNora: [signNora, setSignNora],
  sendFinalMessage: [sendFinalMessage, setSendFinalMessage],
  checkMeteo: [checkMeteo, setCheckMeteo],
  selectedSteps,
  initialMessages
}) => (
  <div className="nsec community-section">
    <div className="nsec__head">
      <div className="nsec__ico">
        <i className="pi pi-check-circle" style={{ fontSize: 16 }} />
      </div>
      <h3 className="nsec__title">{t.controlliIA}</h3>
    </div>
    <div className="nsec__body">
      <div className="nrow nrow--top">
        <CheckboxPanel
          checked={checkAutomaticHotel}
          onChange={setCheckAutomaticHotel}
          headerValue={t.hotelAutomatico}
          description={t.hotelAutomaticoDescrizione}
        />
        <CheckboxPanel
          checked={checkControlliIA}
          onChange={setCheckControlliIA}
          headerValue={t.verificaConfermaDatiIA}
          description={t.verificaConfermaDatiIADescrizione}
        />
        <CheckboxPanel
          checked={checkChiediMezzoDiTrasporto}
          onChange={setCheckChiediMezzoDiTrasporto}
          headerValue={t.richiediMezzoTrasporto}
          description={t.richiediMezzoTrasportoDescrizione}
        />
        <CheckboxPanel
          checked={signNora}
          onChange={setSignNora}
          headerValue={t.abilitaMessaggiFirmati}
          description={t.abilitaMessaggiFirmatiDescrizione}
        />
        <CheckboxPanel
          checked={sendFinalMessage}
          onChange={setSendFinalMessage}
          headerValue={t.abilitaMessaggioFinale}
          description={t.abilitaMessaggioFinaleDescrizione}
        />
        {sendFinalMessage && (
          <CheckboxPanel
            checked={checkMeteo}
            onChange={setCheckMeteo}
            headerValue={t.aggiungiInformazioniMeteo}
            description={t.aggiungiInformazioniMeteoDescrizione}
          />
        )}
        {sendFinalMessage && (
          <CheckboxPanel
            checked={checkUserRedirectToOperatorMessage}
            onChange={setCheckUserRedirectToOperatorMessage}
            headerValue={t.messaggioPreimpostatoUtente}
            description={t.messaggioPreimpostatoUtenteDescrizione}
          />
        )}
        {selectedSteps === '2' && (
          <>
            <CheckboxPanel
              checked={checkPubblicaLoStesso}
              onChange={setCheckPubblicaLoStesso}
              headerValue={t.pubblicaLoStesso}
              description={t.pubblicaLoStessoDescrizione}
            />
            <CheckboxPanel
              checked={checkControllaPreventivi}
              onChange={setCheckControllaPreventivi}
              headerValue={t.controllaPreventivi}
              description={t.controllaPreventiviDescrizione}
            />
          </>
        )}
      </div>

      {sendFinalMessage && checkUserRedirectToOperatorMessage && (
        <div style={{ marginTop: 16 }}>
          <div className="nfield" style={{ marginBottom: 12 }}>
            <label>{t.messaggioReindirizzamentoOperatore}</label>
            <div className="nfield__hint">{t.messaggioReindirizzamentoOperatoreDescrizione}</div>
          </div>
          <Editor
            id="userRedirectToOperatorMessage"
            onChange={({ userRedirectToOperatorMessage: changedUserRedirectToOperatorMessage }) =>
              changedUserRedirectToOperatorMessage.trim() !==
                userRedirectToOperatorMessage.trim() &&
              setUserRedirectToOperatorMessage(changedUserRedirectToOperatorMessage)
            }
            initialValue={initialMessages.userRedirectToOperatorMessage || ''}
          />
        </div>
      )}
    </div>
  </div>
)

export default Controlli
